module.exports = function (n) {
  return 0 <= n && n < 2 ? "one" : "other";
};